<template>
	<section>
		<!--工具条-->
		<el-row :gutter="12" class="toolbar" style="padding:10px 0px;background: #f5f7f9;">
		  <el-col :span="8">
			<el-card shadow="hover" :body-style="{ height: '100px' }">
			  <div style="text-align:center;">
			    <h4>今日新增用户</h4>
				<span style="font-size: 30px;">{{summary.today_news_user}}</span>
			  </div>
			</el-card>
		  </el-col>
		  <el-col :span="8">
			<el-card shadow="hover" :body-style="{ height: '100px' }">
			  <div style="text-align:center;">
			    <h4>今日活跃用户</h4>
				<span style="font-size: 30px;">{{summary.today_dau_user}}</span>
			  </div>
			</el-card>
		  </el-col>
		  <el-col :span="8">
			<el-card shadow="hover" :body-style="{ height: '100px' }">
			  <div style="text-align:center;">
			    <h4>今日注册用户</h4>
				<span style="font-size: 30px;">{{summary.today_register_user}}</span>
			  </div>
			</el-card>
		  </el-col>
        </el-row>
		
		<el-col :span="24">
			<el-form :inline="true">				
				<el-form-item>
					  <el-select size="small" style="width:120px;"clearable  @change="handChange" v-model="field" placeholder="请选择">
						<el-option key="1" label="设备号" value="device_id"></el-option>
						<el-option key="2" label="手机号" value="phone"></el-option>
						<el-option key="3" label="推广码" value="code"></el-option>
					  </el-select>
					  <el-input size="small" style="width:150px;" v-model="keyword" :placeholder="placeholder"></el-input>
				</el-form-item>				
				<el-form-item>
					<el-button  size="small" v-on:click="getUsers"><i  class="el-icon-search"></i> 查询</el-button>
				</el-form-item>				
			</el-form>
			
		</el-col>

		<!--列表-->
		<el-table :data="users" highlight-current-row v-loading="listLoading"  @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column type="index" label="序号" width="50">
			</el-table-column>
			<el-table-column prop="device_id" label="设备号" align="center" width="180"></el-table-column>
			<el-table-column prop="phone" label="手机号" align="center" width="100">
			</el-table-column>
			<el-table-column  label="等级"  align="center">
			 <template slot-scope="scope">
			  <el-tag size="small" type="warning">{{formatLevel(scope.row.level)}}</el-tag>
			 </template>
			</el-table-column>
			<el-table-column prop="watch_num" label="次数" align="center" min-width="80"></el-table-column>
			<el-table-column prop="cache_num" label="次数" align="center" min-width="80"></el-table-column>
			<el-table-column prop="spread_num" label="人数" align="center" min-width="80"></el-table-column>
			<el-table-column prop="code" label="推广" align="center" min-width="100"></el-table-column>
			<el-table-column prop="date" label="创建时间" align="center" min-width="120"></el-table-column>
			<el-table-column label="操作" align="center" width="150">
				<template slot-scope="scope">
					<el-button type="text"  plain size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="text" style="color:#909399;" size="mini" @click="ToDetail(scope.row)">展开详情</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button>
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" width="45%" :visible.sync="editFormVisible" :close-on-click-modal="false">
			<el-form  :model="editForm" label-width="80px" ref="editForm">
				<el-form-item label="用户名称">
					<el-input v-model="editForm.username" disabled style="width:180px;" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="观看次数">
					<el-input-number v-model="editForm.watch_num" :min="-1"></el-input-number>
				</el-form-item>
				<el-form-item label="缓存次数">
					<el-input-number v-model="editForm.cache_num" :min="0"></el-input-number>
				</el-form-item> 
				<el-form-item label="等级设置">
					<el-radio-group v-model="editForm.level">
						<el-radio v-for="item in levellist" :key="item.id" :label="item.level">{{item.name}}</el-radio>
					  </el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import util from '../../common/js/util'
	import { getUserListPage, batchRemoveUser,getLevelList,editUser,getSumaryUser } from '../../api/api';

	export default {
		data() {
			return {
				keyword: '',
				levellist:[],
				users: [],
				total: 0,
				field:'device_id',
				page: 1,
				summary:{},
				listLoading: false,
				sels: [],//列表选中列
				editFormVisible: false,
				placeholder:'设备号',
				editLoading: false,
				editForm: {}
			}
		},
		methods: {
			formatLevel(level) {
				let obj = this.levellist.find( item=>item.level==level );
				return obj.name
			},
			handleCurrentChange(val) {
				this.page = val;
				this.getUsers();
			},
			handChange(val){
			  switch(val){
			    case 'device_id':
				this.placeholder ='设备号'
				break;
				case 'phone':
				this.placeholder ='手机号'
				break;
				case 'code':
				this.placeholder ='推广码'
				break;
			  }
			},
			ToDetail(row)
			{
			  this.$router.push(`/detail/${row.device_id}/${row.id}`)
			},
			getSummary()
			{
			 getSumaryUser({}).then((res)=>{
			      this.summary = res.data
			  })
			},
			getLevelList(){
			  getLevelList({}).then((res)=>{
			      this.levellist = res.data
			  })
			},
			//获取用户列表
			getUsers() {
				let para = {
					page: this.page,
					keyword: this.keyword,
					field:this.field
				};
				this.listLoading = true;
				getUserListPage(para).then((res) => {
					this.total = res.data.total;
					this.users = res.data.users;
					this.listLoading = false;
				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
			},
			//编辑
			editSubmit: function () {				
				this.editLoading = true;
				let para ={
					id:this.editForm.id,
					watch_num:this.editForm.watch_num,
					cache_num:this.editForm.cache_num,
					level:this.editForm.level
				}
				editUser(para).then((res) => {
					this.editLoading = false;
					this.$message({
						message: '修改成功',
						type: 'success'
					});
					this.$refs['editForm'].resetFields();
					this.editFormVisible = false;
					this.getUsers();
				});				
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					let para = { ids: ids };
					batchRemoveUser(para).then((res) => {
						this.listLoading = false;
						this.$message({
							message: '删除成功',
							type: 'success'
						});
						this.getUsers();
					});
				}).catch(() => {

				});
			}
		},
		mounted() {
			this.getSummary()
			this.getUsers();
			this.getLevelList();			
		}
	}

</script>

<style>
 .el-table td, .el-table th{padding:6px 0px;}
 .el-input__icon{height:auto;}
 .cell{font-size:12px;}
</style>


// WEBPACK FOOTER //
// user.vue?60eb1e6a